import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a pony / half wall: 1.0 m high with a small oak cap board on
// top, for room dividers, kitchen counters and stair guards. Same footprint
// line as wall-plain (along X through the tile centre, 0.12 thick).
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";
const OAK = "#c8975a";

export const wallHalf = defineModel({
  id: "wall-half",
  batchId: "modern",
  name: "Half wall",
  tags: ["modern", "interior", "structure", "wall", "half-wall", "divider"],
  summary: "A 1 m high pony wall with an oak cap board.",
  description:
    "A one-tile pony wall of the Modern Living kit: plastered, 0.12 m " +
    "thick, 1.0 m high overall with a small oak cap board on top. Runs " +
    "along X through the tile centre like every wall piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // the wall body (up to the underside of the cap)
      { geometry: new THREE.BoxGeometry(1.0, 0.95, 0.12), color: PLASTER, position: [0, 0.475, 0] },
      // oak cap board, slightly proud of the wall faces
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.18), color: OAK, position: [0, 0.975, 0] },
      // baseboard
      { geometry: new THREE.BoxGeometry(1.0, 0.1, 0.15), color: BASEBOARD, position: [0, 0.05, 0] },
    ];
  },
  animations: [],
});
